import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const SumGreenWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default SumGreenWorkReport
